import React from "react"
import Logo from '../img/CEL_logo.webp'

const Header = () => {

  return(
    <div className="header-container">
      <div>
        <img src={Logo} alt="logo" className="cel-logo"/>
      </div>
      <div className="header-info-box">
        <div className="header-info">
          <p>
            Days: Open 7 Days a Week | Hours: 8am - 9pm Last Wash 
          </p>
          <p className="header-contacts">
            | Phone: <a href="tel:+15417521251" className="header-contact">(541) 752-1251</a>
          </p>

        </div>  
        <div className="header-buttons">
          <a href="/" className="buttons">Home</a>
          <a href="/clean-commitment" className="buttons">Corvallis Eco Laundry Commitment</a>
          <a href="/testimonials" className="buttons">Testimonials</a>
          <a href="/Contact" className="button-info">Contact Us</a>
        </div>
      </div>
    </div>
  )
}

export default Header
